import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken, setToken } from './auth'
import router from '@/router'

// 生产环境通过 VUE_APP_API_BASE_URL 指定后端域名（如 https://api.fanxingtech.online），开发环境走相对路径由 devServer 代理
const apiBase = process.env.VUE_APP_API_BASE_URL ? `${process.env.VUE_APP_API_BASE_URL}/api` : '/api'

const request = axios.create({
  baseURL: apiBase,
  timeout: 30000
})

// 统一的 401 处理：提示、清除登录态并跳转登录页
export function handleUnauthorized(message) {
  Message.error(message || '登录已过期，请重新登录')
  removeToken()
  // 强制刷新页面到登录页
  if (window.location.pathname !== '/login') {
    window.location.href = '/login'
  }
}

request.interceptors.request.use(
  config => {
    const token = getToken()
    console.log('请求拦截器 - 当前token:', token)
    console.log('请求拦截器 - 请求URL:', config.url)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      console.log('请求拦截器 - 已添加Authorization头')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  response => {
    const res = response.data
    // Token续期：每次成功请求后，将新token保存到cookie
    if (response.headers['new-token']) {
      const newToken = response.headers['new-token']
      console.log('收到新token，更新本地token')
      setToken(newToken)
    }

    if (res.code !== 200) {
      // 如果返回码是401，说明token失效，清除token并跳转到登录页
      if (res.code === 401) {
        handleUnauthorized(res.message)
        return Promise.reject(new Error(res.message || '登录已过期'))
      }
      // 其他业务错误不自动提示，由业务代码处理
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    if (error.response) {
      const { status } = error.response
      // HTTP状态码401，token失效
      if (status === 401) {
        handleUnauthorized()
        return Promise.reject(error)
      }
    }
    // 如果响应数据中的code是401，也视为token失效
    if (error.response && error.response.data && error.response.data.code === 401) {
      handleUnauthorized(error.response.data.message)
      return Promise.reject(error)
    }
    Message.error(error.message || '请求失败')
    return Promise.reject(error)
  }
)

export default request
